import React, {Component} from 'react'
import { Row, Col } from 'react-bootstrap'
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore'

const month_full = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤษจิกายน", "ธันวาคม"]
class PrintQuotationDoc2 extends Component {

  constructor(...args){
    super(...args)
    this.state = {page_title:'กำลังดึงข้อมูล..',defaultTypePrint:'3',loading:false, data:{
    car:{car_registration_no:'',brand:'',model:'',car_no:'',vehicle_code:'',province:'',year:'',chassis_no:'',engine_no:''},
    insurer:{insurer_id:'',insurer_name:''},
    receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:'',fixing_day:'',credit_day:''},
    wagelist:[],partlist:[],total_amount:'' ,vat:'',grand_total:'',grand_total_thai:''
  }}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData(){
    let {data} = this.state
    this.setState({loading:true})
    let that = this
    if(this.props.fileId!==''){
      PdfStore.loadQuotationFileDoc(this.props.fileId,this.props.mode,this.props.sheetId,function(result){
        let newData = result.data
        newData['receiving'] = Object.assign(data.receiving,newData.receiving)
        newData['car'] = Object.assign(data.car,newData.car)
        //console.log('data',data)
        that.setState({loading:false,data:newData})
      },function(){
        that.setState({loading:false})
      })
    }else if(this.props.qoNo!==''){
      PdfStore.loadQuotationDoc(this.props.qoNo,function(result){
        let data = result.data

        that.setState({loading:false,data:data})
      },function(){
        that.setState({loading:false})
      })
    }
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  renderQODate(qoDate){
    let list = (qoDate+"").split("/");
    

    if(list.length===3){
      return (<span>วันที่ {list[0]} เดือน {month_full[(list[1]*1)-1]} พ.ศ. {list[2]}</span>)
    }
    return (<span>{qoDate}</span>)
  }

  renderAllListRow(allList) {
    let wagelist = []
    let partlist = []
    allList.forEach(function(item,index) {
      if (item.type==='wage') {
        wagelist.push(item)
      } else {
        partlist.push(item)
      }
    })
    if (wagelist.length===1&&wagelist[0].item_seq===undefined) {
      wagelist = []
    }
    if (partlist.length===1&&partlist[0].item_seq===undefined) {
      partlist = []
    }
    return([
        wagelist.length>0?this.renderWageListRow(wagelist):'',
        partlist.length>0?this.renderPartListRow(partlist):''
      ])  
  }

  renderWageListRow(wagelist){
    return([
      <tr key={10000} className='font-16'>
        <td className="text-center">
          <div>ลำดับที่</div>
          <div>No</div>
        </td>
        <td className="text-center" colSpan={3}>
          <div>รายการค่าแรงซ่อม - รายการอะไหล่</div>
          <div>(Repair of wages - Parts list)</div>
        </td>
        <td className="text-center">
          <div>จำนวน</div>
          <div>Number</div>
        </td>
        <td className="text-center">
          <div>หน่วย</div>
          <div>Unit</div>
        </td>
        <td className="text-center">
          <div>ราคาค่าแรง</div>
          <div>(Wage Rates)</div>
          <div>บาท (Bath)</div>
        </td>
        <td className="text-center">
          <div>ราคาค่าอะไหล่</div>
          <div>(Spare parts)</div>
          <div>บาท (Bath)</div>
        </td>
      </tr>,
      <tr className='font-16'>
        <td className="text-center">

        </td>
        <td className="text-center" colSpan={3}>
          รายการค่าแรงซ่อม (Repair of wages)
        </td>
        <td className="text-center">

        </td>
        <td className="text-center">

        </td>
        <td className="text-center">

        </td>
        <td className="text-center">

        </td>
      </tr>,      
      wagelist.map((item,index)=>(
        this.renderPartsList(item.item_seq,item.detail,item.quantity,item.unit,item.amount,'','')   
      ))        
    ])
  }

  renderPartListRow(partlist){
    return (
        [     <tr key={20000}>
                <td className="text-center">
                  
                </td>
                <td className="text-center" colSpan={3}>
                  <br/>            
                </td>
                <td className="text-center">
                  
                </td>
                <td className="text-center">
                  
                </td>
                <td className="text-center">
                  
                </td>
                <td className="text-center">
                  
                </td>
              </tr>,
              <tr key={20001}>
                <td className="text-center">
                  
                </td>
                <td className="text-center" colSpan={3}>
                  <div>รายการอะไหล่ ( Parts List )    </div>                  
                </td>
                <td className="text-center">
                  
                </td>
                <td className="text-center">
                  
                </td>
                <td className="text-center">
                  
                </td>
                <td className="text-center">
                  
                </td>
              </tr> ,              
                partlist.map((item,index)=>(
                  this.renderPartsList(item.item_seq,item.detail,item.quantity,item.unit,'',item.amount,'')   
                ))
              ] 
    )
  }

  getCreditDay(credit_day){
    if(credit_day==undefined){
      return 'ตามเงื่อนไขกำหนด'
    }else{
      return 'เครดิต '+credit_day+' วัน'
    }
  }

  renderComponentPage(itemlist,itemIndex) {
    
    if (itemlist.data.data.length===1&&itemlist.data.data[0].item_seq===undefined) {
      itemlist.data.data = []
    }

    let {data,defaultTypePrint} = this.state
    let {receiving,car,insurer,wagelist,partlist,total_amount,vat,grand_total,grand_total_thai} = data
    

    return(
      <div className='font-print '>
        <header>
          <h2 className="text-right">{'ใบเสนอราคา'}</h2>
        </header>  
        <article className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>รับ เคาะ ปะผุ พ่นสี รถยนต์ ทุกชนิด รับขึ้นตัวถังตู้แห้ง  และกระบะรถบรรทุก</p>               
              <p style={{lineHeight:'0.7'}}>รับดัดครัซซี  และรับพ่นทรายงานทุกประเภท  รับซ่อมเครื่องยนต์ และระบบช่วงล่างรถทุกชนิด</p>              
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร/call {data.company_tel} โทรสาร/fax {data.company_fax} เลขที่ผู้เสียภาษี {data.company_tax}</p>              
            </strong>
          </section>
          <section className='text-right sec-copy-doc'>
            <div className='qo-no'>
              เลขที่ <br/>
              {data.quotation_no} 
            </div> 
            <span style={{display:defaultTypePrint=='0'?'none':''}}>{itemlist.type=='ori'?'ต้นฉบับ':itemlist.type=='copy'?'สำเนา':''}</span>  
          </section>
        </article>
        <div className="box-quotation-doc font-16">
          <table className="table table-bordered table-quotation-doc font-15">
            <tbody>
              <tr>
                <td rowSpan={2}>
                  <div>ข้อมูล</div>
                  <div>ลูกค้า</div> 
                  <div>Customer</div>
                  <div>data</div>
                </td>
                <td className='w-print hr-r-none' style={{width:'180px'}} rowSpan={2}>
                  <div>ชื่อเจ้าของรถ Owner's name</div>
                  <div>ที่อยู่ Address</div>                  
                  <div>เบอร์โทรติดต่อ Phone number</div>
                  <div>Owner's name</div>
                  <div>ที่อยู่ Address</div>                  
                  <div>เบอร์โทรติดต่อ Phone number</div>               
                </td>
                <td colSpan={4} rowSpan={2}>
                  <div>{data.customer_name}</div>
                  <div>{data.customer_address}</div>                  
                  <div>โทร call . {data.customer_tel} โทรสาร/Fax.{data.customer_fax}</div>
                  <div>{data.insurer_name}</div>
                  <div>{data.insurer_address}</div>                  
                  <div>{data.insurer_tel} {data.insurer_fax}</div>
                </td>
                <td className="text-center" colSpan={2}>
                  <div>วันที่เสนอราคา</div> 
                  <div>Date of quotation</div>
                  <div>{data.quotation_date_text}</div>
                </td>
              </tr>
              <tr>
                <td className="text-center" colSpan={2}>
                  <div>ระยะเวลาซ่อม/Time Repair </div>
                  <div>จำนวนวัน {receiving.fixing_day} วัน</div>
                  <div>เงื่อนไขการชำระเงิน </div>
                  <div>Term of payments {this.getCreditDay(receiving.credit_day)}  </div>
                </td>                
              </tr>
              <tr>                
                <td colSpan={8} className="text-center">
                  รายละเอียดรถ Car detail
                </td>                               
              </tr>
              <tr>
                <td className="text-center" style={{width:'30px'}} rowSpan={5}>
                  <div>แบบรถ</div>
                  <div>type</div>
                  <div>{data.vehicle_type===null?'-':data.vehicle_type===undefined?'-':data.vehicle_type}</div>
                </td>
                <td className="text-center" style={{width:'85px'}}>
                  เลขทะเบียน
                </td>
                <td style={{width:'125px'}}>
                  เลขทีกรมธรรม์ Policy No
                </td>
                <td style={{width:'100px'}} className='text-center'>
                  {data.policy_no}
                </td>
                <td colSpan={2}>
                  เลขตัวถัง Chassis No
                </td>
                <td colSpan={2} className='text-center'>
                  {car.chassis_no}
                </td>
              </tr>
              <tr>
                <td className="text-center">
                  License No
                </td>
                <td>
                  เลขเครม Claim No
                </td>
                <td className='text-center'>
                  {data.claim_no}
                </td>
                <td colSpan={2}>
                  เลขเครื่อง Machine No
                </td>
                <td colSpan={2} className='text-center'>
                  {car.engine_no}
                </td>
              </tr>
              <tr>
                <td className="text-center">                  
                  {data.license_no===null?'-':data.license_no===undefined?'-':data.license_no}
                </td>
                <td>
                  เลขรับแจ้ง Noinformed No
                </td>
                <td className='text-center'>
                  {data.noinformed_no===null?'-':data.noinformed_no===undefined?'-':data.noinformed_no}
                </td>
                <td colSpan={2}>
                  รุ่นปี Model year
                </td>
                <td colSpan={2} className='text-center'>
                  {car.year}
                </td>
              </tr> 
              <tr>
                <td className='text-center'>
                  เบอร์รถ Burton car
                </td>
                <td>
                  เลขที่ C No. C
                </td>
                <td className='text-center'>
                  {data.c_no_c===null?'-':data.c_no_c===undefined?'-':data.c_no_c}
                </td>
                <td colSpan={2}>
                  รหัสรถ Code
                </td>
                <td colSpan={2} className='text-center'>
                   {car.vehicle_code}
                </td>
              </tr>
              <tr>
                <td className='text-center'>
                  {data.burton_car===null?'-':data.burton_car===undefined?'-':data.burton_car}
                </td>
                <td>
                  เครมหจก.Crane LTD
                </td>
                <td className='text-center'>
                  {data.crane_ltd===null?'-':data.crane_ltd===undefined?'-':data.crane_ltd}
                </td>
                <td colSpan={2}>
                  สีรถ Color
                </td>
                <td className={'text-center'} colSpan={2}>
                  {car.color}
                </td>
              </tr>
              {itemlist.data.key==='wage'&&itemlist.data.data.length>0?this.renderWageListRow(itemlist.data.data):''}
              {itemlist.data.key==='part'&&itemlist.data.data.length>0?this.renderPartListRow(itemlist.data.data):''}
              {itemlist.data.key==='all'?this.renderAllListRow(itemlist.data.data):''}
              {itemlist.data.footer==='remark'?this.renderRemark():itemlist.data.footer==='all'?this.renderRemark():''}
              {itemlist.data.footer==='signature'?this.renderTableFooter():itemlist.data.footer==='all'?this.renderTableFooter():''}
            </tbody>
          </table>
        </div>
        {itemlist.data.footer==='signature'?this.renderFooter():itemlist.data.footer==='all'?this.renderFooter():''}
      </div>  
    )
  }

  renderTableFooter(){
    let {data} = this.state
    let {wage_price,part_price,total_amount,vat,grand_total,grand_total_thai} = data

    return ([                          
              this.renderPartsList('','รวมค่าแรง+ค่าอะไหล่','','',wage_price,part_price,'center'),
              this.renderPartsList('','รวมค่าบริการ','','','',total_amount,'center'),
              <tr className='font-16'>
                <td className="hr-b-none hr-r-none hr-l-none"></td>
                <td colSpan={3} className="hr-b-none hr-r-none hr-l-none text-center">จำนวนเงินรวมทั้งสิ้น (ตัวอักษร)</td>
                <td colSpan={3} className="hr-b-none hr-l-none text-center">ภาษีมูลค่าเพิ่ม</td> 
                <td className="text-right">{this.getNumberFormat(vat)}</td>               
              </tr>,
              <tr className='font-16'>
                <td className="hr-b-none hr-r-none hr-l-none"></td>
                <td colSpan={3} className="hr-b-none hr-r-none hr-l-none text-center ">
                  <div className='bg-green-print bg-green text-black '>{grand_total_thai===null?'-':grand_total_thai===undefined?'-':grand_total_thai===''?'-':grand_total_thai}</div>
                </td>
                <td colSpan={3} className="hr-b-none hr-l-none text-center">รวมเป็นเงินทั้งสิ้น</td>     
                <td className="text-right">{this.getNumberFormat(grand_total)}</td>           
              </tr>
    ]
    )
  }

  renderFooter(){
    return (
      <div className="box-foot-quotation-doc footer-page">
          <Row>
            <Col md={6} style={{float:'left'}}>
              <table className="table table-no-border table-quotation-doc-check" style={{marginTop:'15px'}}>
                <tbody>
                  <tr><td className="text-center">ลงชื่อ........................................................................ผู้ตรวจสอบ</td></tr>
                  <tr><td className="text-center">(นาย ไกรวิชญ์ พงษ์เกาะ)</td></tr>
                  <tr><td className="text-center">ฝ่ายประเมินราคา/Appraisal</td></tr>
                  <tr><td className="text-center">บริษัท เคเคซีเกษมการช่าง</td></tr>
                </tbody>
              </table>
            </Col>
            <Col md={6} style={{float:'right'}}>
              <table className="table table-no-border table-quotation-doc-check" style={{marginTop:'15px'}}>
                <tbody>
                  <tr><td className="text-center">ผู้รับซ่อม........................................................................ผู้รับซ่อม</td></tr>
                  <tr><td className="text-center">(นาย สมเดช เรตสันเทียะ)</td></tr>
                  <tr><td className="text-center">ผู้จัดการศูนย์/Manager</td></tr>
                  <tr><td className="text-center">บริษัท เคเคซีเกษมการช่าง</td></tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
    )
  }

  addNewLine(val){
    let valLine = val.split('\\n')
    return valLine.map(function(item, key) {
      return (
        <span key={key} className='remark-content'>
          {item}
          <br/>
        </span>
      )
    })
  }

  addLineBreak(val) {
    const divStyle = {
      whiteSpace: 'pre-line'
    }
    
    return (
      <div style={divStyle}>
        {this.addNewLine(val)}
      </div>
    )
  }

  renderRemark() {
    let remark = this.state.data.remark
      return([
        <tr>
          <td><br/></td>
          <td colSpan={5} rowSpan={8}>
            <div className='remark-title'>หมายเหตุ</div>
            {this.addLineBreak(remark===null?'-':remark===''?'-':remark===undefined?'-':remark)}
          </td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>,
        <tr>
          <td><br/></td>
          <td></td>
          <td></td>
        </tr>
      ])
  }

  // renderRemark() {
  //   return(
  //     <tr>
  //       <td><br/></td>
  //       <td rowSpan={7} colSpan={4}>หมายเหตุ</td>
  //       <td className="text-center">
  //         <table className="table table-sub-quotation-doc">
  //           <tbody>
  //             <tr>
  //               <td className="text-right" style={{width:'75px'}}>
  //                 <br/>
  //               </td>
  //               <td className="text-right bl">
  //                 <br/>
  //               </td>
  //             </tr>
  //           </tbody>  
  //         </table>
  //       </td>
  //     </tr>
  //   )
  // }

  // renderRemark_(number) {
    
  //   return(
  //     new Array(number).fill('').map((item,index) => {
  //       return(
  //         <tr key={index}>
  //           <td><br/></td>
  //           <td className="text-center">
  //             <table className="table table-sub-quotation-doc">
  //               <tbody>
  //                 <tr>
  //                   <td className="text-right" style={{width:'75px'}}>
  //                     <br/>
  //                   </td>
  //                   <td className="text-right bl">
  //                     <br/>
  //                   </td>
  //                 </tr>
  //               </tbody>  
  //             </table>
  //           </td>
  //         </tr>
  //       )
  //     })
  //   )  
  // }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderPartsList(order,list,qu,unit,price,amount,align='left') {
    return(
      <tr className='font-16'>
        <td className="text-center">
          {order}
        </td>
        <td colSpan={3} className={'text-'+align}>
          {list}
        </td>
        <td className="text-center" style={{width:'75px'}}>
          {qu}
        </td>
        <td className="text-center" style={{width:'40px'}}>
          {unit}
        </td>
        <td className="text-right" style={{width:'75px'}}>
          {this.getNumberFormat(price)}
        </td>
        <td className="text-right" style={{width:'75px'}}>
          {this.getNumberFormat(amount)}
        </td>
      </tr>
    )
  }

  onTypePrintChange(e) {
  	this.setState({defaultTypePrint:e})  
  }

  setPageRender(dataList,defaultTypePrint) {
    let pages = []
    dataList.forEach((item,index)=>{
        if (defaultTypePrint=='1'||defaultTypePrint=='3'||defaultTypePrint=='0') {
            pages.push({
                page:index+1,
                type:'ori',
                data:item
            })
        } else if (defaultTypePrint=='2') {
            pages.push({
                page:index+1,
                type:'copy',
                data:item
            })
        }
    })
    if (defaultTypePrint=='3'||defaultTypePrint=='0') {
        pages.forEach((item,index)=>{
            pages.push({
                page:pages[pages.length-1].page+1,
                type:'copy',
                data:item.data
            })
        })
    }
    return pages
  }

  render() {
    let {loading,data,defaultTypePrint} = this.state
    let {wagelist,partlist} = data
    let allList = []

    wagelist.forEach(function(item,index) {
      wagelist[index]['type'] = 'wage'
      allList.push({
        key: 'wage',
        data: item
      })
    })
    if (wagelist.length===0) {
      allList.push({
        key: 'wage',
        data: {type:'wage'}
      })
    }
    partlist.forEach(function(item,index) {
      partlist[index]['type'] = 'part'
      allList.push({
        key: 'part',
        data: item
      })
    })
    if (partlist.length===0) {
      allList.push({
        key: 'part',
        data: {type:'part'}
      })
    }
    let count = 0
    let items = []
    let setList = []
    let checkWage = false
    let checkPart = false
    allList.forEach(function(item,index) {
      if (count<=31) {
        if (item.key==='wage') {
          checkWage = true
        } else if (item.key==='part') {
          checkPart = true
        }
        items.push(item.data)
      }
      if (count===31||index===allList.length-1) {
        let key = item.key
        if (checkWage===true&&checkPart===true) {
          key = 'all'
        }
        setList.push({
          key: key,
          data: items
        })
        checkWage = false
        checkPart = false
        items = []
        count = -1
      }
      count++
    })

    setList.forEach(function(item,index) {
      if (setList.length-1===index&&32-item.data.length>12) {
        setList[index]['footer'] = 'all'
      }  
      else if (setList.length-1===index&&32-item.data.length>8&&32-item.data.length<=12) { 
        setList[index]['footer'] = 'remark'
        setList.push({
          key: "-", 
          data: [],
          footer: "signature"
        })
      } else if (setList.length-1===index&&32-item.data.length<=8&&32-item.data.length>5) {
        setList[index]['footer'] = 'remark'
        setList.push({
          key: "-", 
          data: [],
          footer: "signature"
        })
      } else if (setList.length-1===index&&32-item.data.length<=5) {
        setList.push({
          key: "-", 
          data: [],
          footer: "all"
        })
      }
    })
    let pages = this.setPageRender(setList,defaultTypePrint)
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบเสนอราคา '+this.props.qoNo}
        onTypePrintChange={this.onTypePrintChange.bind(this)}
        defaultTypePrint={this.state.defaultTypePrint}
      >
        {
          pages.map((item,index) => {
            return(
              this.renderComponentPage(item,index)
            )
          })
        }
      </PrintPreview>
    )
  }

}  

PrintQuotationDoc2.defaultProps = {
  title: 'ใบเสนอราคา',  
  mode : '2',
  fileId: '',
  qoNo:'',
  sheetId:0
}
export default PrintQuotationDoc2;


// WEBPACK FOOTER //
// ./src/view/print/PrintQuotationDoc2.js